<template>
  <base-input
    v-model="formData"
    :error="validateValue(formData)"
    mask="integer"
    placeholder="Ex: 300"
  />
</template>

<script>
export default {
  name: "NumberAvaliationItemStrategy",
  props: {
    value: {},
    avaliationItem: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  methods: {
    validateValue(value) {
      if (this.min && value < this.min) {
        return `O valor deve ser maior ou igual a ${ this.min }`;
      }

      if (this.max && value > this.max) {
        return `O valor deve ser menor ou igual a ${ this.max }`;
      }

      return;
    },
  },
  computed: {
    formData: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    config() {
      return this.avaliationItem.config || {};
    },
    min() {
      return this.config.min_value || 1
    },
    max() {
      return this.config.max_value || 10
    },
  },
}
</script>

